module.exports = __webpack_public_path__ + "img/affirm-logo.1fadec47.svg";